import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiClient } from "../../utils/ApiClient";
import { RequestStatus } from "../../utils/Enums";
import {PerformanceIndicator} from "../../models/PerformanceIndicator";

interface PerformanceIndicatorsState {
    indicators: PerformanceIndicator[];
    total: any;
    status: RequestStatus;
}

const initialState: PerformanceIndicatorsState = {
    indicators: [],
    total: null,
    status: RequestStatus.Idle,
};

export const getPerformanceIndicators = createAsyncThunk(
    'performanceIndicators/getPerformanceIndicators',
    async ({ user, week }: { user: number, week: number }, { rejectWithValue }) => {
        const response = await apiClient.get(`performance/weekly?user=${user}&week=${week}`);
        return response.data;
    }
);


export const getTotal = createAsyncThunk(
    'performanceIndicators/getTotal',
    async ({ week, year }: { week: number, year: number }, { rejectWithValue }) => {
        const response = await apiClient.get(`performance/total?week=${week}&year=${year}`);
        return response.data;
    }
);

const performanceIndicatorsSlice = createSlice({
    name: 'performanceIndicators',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getPerformanceIndicators.pending, (state) => {
                state.status = RequestStatus.Loading;
            })
            .addCase(getPerformanceIndicators.fulfilled, (state, action) => {
                state.status = RequestStatus.Success;
                state.indicators = action.payload;
            })
            .addCase(getPerformanceIndicators.rejected, (state, action) => {
                state.status = RequestStatus.Failed;
            })

            .addCase(getTotal.pending, (state) => {
                state.status = RequestStatus.Loading;
            })
            .addCase(getTotal.fulfilled, (state, action) => {
                state.status = RequestStatus.Success;
                state.total = action.payload;
            })
            .addCase(getTotal.rejected, (state, action) => {
                state.status = RequestStatus.Failed;
            });
        ;
    },
});

export default performanceIndicatorsSlice.reducer;